import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ChargingStationsApiService } from '@kempoweroyj/ngx-charging-stations-api-client';

@Injectable({
    providedIn: 'root',
})
export class StationNavigationService {
    // Pattern to match station IDs that start with 'CS' (case-insensitive)
    private stationIdPattern = /^cs/i;

    constructor(
        private router: Router,
        private stationsApi: ChargingStationsApiService
    ) {}

    async tryNavigateToStation(inputValue: string, callback: (navigated: boolean) => void): Promise<void> {
        const trimmedValue = inputValue.trim();

        if (this.stationIdPattern.test(trimmedValue)) {
            try {
                const station = await this.stationsApi.getChargingStation(trimmedValue);
                await this.router.navigate(['locations', 'station', station.station.stationId]);
                callback(true); // Indicate that navigation was performed
            } catch (_error) {
                callback(false); // Indicate that navigation was not performed due to an error
            }
        } else {
            callback(false); // Indicate that navigation was not performed because the input did not match the pattern
        }
    }
}
